"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Translation Registry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyExperimentConfigToJSON = exports.CopyExperimentConfigFromJSONTyped = exports.CopyExperimentConfigFromJSON = exports.instanceOfCopyExperimentConfig = void 0;
var runtime_1 = require("../runtime");
var CopyExperimentSettings_1 = require("./CopyExperimentSettings");
/**
 * Check if a given object implements the CopyExperimentConfig interface.
 */
function instanceOfCopyExperimentConfig(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCopyExperimentConfig = instanceOfCopyExperimentConfig;
function CopyExperimentConfigFromJSON(json) {
    return CopyExperimentConfigFromJSONTyped(json, false);
}
exports.CopyExperimentConfigFromJSON = CopyExperimentConfigFromJSON;
function CopyExperimentConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'experimentTagname': !(0, runtime_1.exists)(json, 'experiment_tagname') ? undefined : json['experiment_tagname'],
        'hashedExperimentTagname': !(0, runtime_1.exists)(json, 'hashed_experiment_tagname') ? undefined : json['hashed_experiment_tagname'],
        'settings': !(0, runtime_1.exists)(json, 'settings') ? undefined : (0, CopyExperimentSettings_1.CopyExperimentSettingsFromJSON)(json['settings']),
    };
}
exports.CopyExperimentConfigFromJSONTyped = CopyExperimentConfigFromJSONTyped;
function CopyExperimentConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'experiment_tagname': value.experimentTagname,
        'hashed_experiment_tagname': value.hashedExperimentTagname,
        'settings': (0, CopyExperimentSettings_1.CopyExperimentSettingsToJSON)(value.settings),
    };
}
exports.CopyExperimentConfigToJSON = CopyExperimentConfigToJSON;
